import { render, staticRenderFns } from "./SharedProjectList.vue?vue&type=template&id=6cb59d5e"
import script from "./SharedProjectList.vue?vue&type=script&lang=js"
export * from "./SharedProjectList.vue?vue&type=script&lang=js"
import style0 from "./SharedProjectList.vue?vue&type=style&index=0&id=6cb59d5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports